import { Product, ProductHelper } from './product';
import { SearchParams, SearchParamsHelper } from './searchParams';

export interface Search {
    total: number;
    products: Product[];
    params: SearchParams;
}

export class SearchHelper {

    static create(obj: Object = {}): Search {
        const ini = {
            total: 0,
            products: [],
            params: SearchParamsHelper.create()
        };

        return Object.assign(ini, obj);
    }

    static transformFromApi(apiData: Object[], environment: any) {
        const search = SearchHelper.create();

        search.total = apiData.length;
        search.products = [];

        for (const row of apiData) {
            const product = ProductHelper.transformFromApi(row, environment);
            search.products.push(product);
        }

        return search;
    }
}
